import { Carousel, Slide } from 'vue-carousel';

export default {
  data() {
    return {
      perPageCustom: [[320, 3], [768, 4], [1024, 6], [1920, 6]],
      scrollPerPage: true,
      paginationEnabled: false,
      navigationEnabled: false,
      autoplay: false,
      autoplayTimeout: 5000,
      centerMode: false,
    }
  },
  methods: {},
  components: {
    Carousel,
    Slide
  }
}
